import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [className]
 * @prop {number} [indexItem]
 * @prop {number} [currentItem]
 * @prop {() => void} [onClick]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifDropdownItem = (props) => {
  const { children, className = '', indexItem = 0, currentItem = 0, onClick = null, ...other } = props;
  const menuItemRef = useRef();

  useEffect(() => {
    if (currentItem === indexItem) {
      menuItemRef.current.focus();
    }
  }, [currentItem]);

  const classes = classNames({
    'motif-dropdown-item': true,
    [className]: true
  });

  const handleKeyDown = event => {
    const { key } = event;

    switch (key) {
      case 'Enter':
        event.preventDefault();
        onClick();
        break;

      default:
        break;
    }
  };

  return (
    <button
      ref={menuItemRef}
      role="menuitem"
      className={classes}
      tabIndex="-1"
      onClick={() => onClick()}
      onKeyDown={handleKeyDown}
      {...other}
      data-motif-dropdown-item
    >
      {children}
    </button>
  );
};

MotifDropdownItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  indexItem: PropTypes.number,
  currentItem: PropTypes.number,
  onClick: PropTypes.func
};

export { MotifDropdownItem };
